import(/* webpackMode: "eager" */ "/var/www/SOC/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/var/www/SOC/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["Share"] */ "/var/www/SOC/src/components/share/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JobsSection"] */ "/var/www/SOC/src/sections/jobs/index.tsx");
